import { MODAL_NONE } from '@components/App/Modal/constants'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { artBoardActions } from '@store/reducers/artboard'
import type { ArtBoardCursorMode } from '@store/reducers/artboard/types'
import { useDispatch, useSelector } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { useArtboardMode } from '@/hooks'
import type { AppState } from '@/types'
import { allowEventTarget } from '@/utils/allowEventTarget'
import { Keys } from '../keyboard'

export const useOnCursorModeKeyboardActions = () => {
  const dispatch = useDispatch()

  const modalType = useSelector<AppState, string>(({ ui }) => ui.modalType)

  const canEdit = useSelector(migrationProjectSelector.getProjectAccessCanEdit)

  const { edit, simpleView } = useArtboardMode()

  const setCursorMode = (mode: ArtBoardCursorMode) => {
    dispatch(artBoardActions.setCursorMode(mode))
  }

  const setGrabMode = (event: KeyboardEvent) => {
    event.preventDefault()

    setCursorMode('grab')
  }

  const setSelectMode = (event: KeyboardEvent) => {
    event.preventDefault()

    setCursorMode('select')
    sendGtmEvent(GtmTriggerName.MULTISELECT_MODE_ON)
  }

  return (event: KeyboardEvent) => {
    // Ноды в Hide Blocks выделяются и перетаскиваются (OCT-5138), значит и
    // переключение курсора между grab и select там нужно.
    if (modalType !== MODAL_NONE || (!edit && !simpleView)) {
      return
    }

    if (!allowEventTarget(event)) {
      return
    }

    // V — Default, Shift+V — Select pages (OCT-5195); Mod+V stays Paste
    if (
      event.code !== Keys.V ||
      event.ctrlKey ||
      event.metaKey ||
      event.altKey
    ) {
      return
    }

    if (!event.shiftKey) {
      setGrabMode(event)

      return
    }

    if (canEdit) {
      setSelectMode(event)
    }
  }
}
